<!-- MOLECULE: AccountMenuCardSignOut.vue -->
<!-- Sign-out button displayed at the bottom of the account menu card. -->

<script setup lang="ts">
//
// Props & Emits
//
defineProps<{ logout: () => void }>();

//
// Composables
//

// Localization
const { t } = useI18n();
</script>

<template>
  <v-tooltip location="bottom" :open-delay="700" :close-delay="300">
    <template #activator="{ props: tooltipProps }">
      <v-hover>
        <template #default="{ isHovering, props: hoverProps }">
          <div
            v-bind="{ ...tooltipProps, ...hoverProps }"
            class="text-caption px-8 d-flex align-center ga-2 py-1 cursor-pointer"
            :class="{ 'bg-secondary': isHovering }"
            @click="logout"
          >
            <v-icon icon="mdi-login-variant" size="small" />
            <span>
              {{ t("components.common.app-bar.app_bar_actions.account_menu.account_menu_card.sign_out.title") }}
            </span>
          </div>
        </template>
      </v-hover>
    </template>

    <span>
      {{ t("components.common.app-bar.app_bar_actions.account_menu.account_menu_card.sign_out.tooltip") }}
    </span>
  </v-tooltip>
</template>
